export interface AccountCheckNoticeProps {
  /** The localized message shown next to the spinner. */
  message: string
}

/**
 * Full-viewport overlay shown while the app is checking Apple's cross-team
 * repair flow for an existing account, right before the browser navigates
 * away to Apple's consent screen a second time.
 *
 * `role="status"` + `aria-live="polite"` rather than a dialog: there is
 * nothing to interact with and nothing to dismiss -- it is a status update
 * the user should hear about, not a prompt awaiting a response. It renders
 * for a fixed, deliberate delay (see `APPLE_REPAIR_NOTICE_DELAY_MS` in
 * `@wehunt/core-web`'s appleRepairFlow.ts) precisely so it has time to be
 * seen before that navigation replaces the page.
 */
export function AccountCheckNotice({ message }: AccountCheckNoticeProps) {
  return (
    <div className="wh-account-check-overlay" role="status" aria-live="polite">
      <div className="wh-account-check-card">
        <span className="wh-account-check-spinner" aria-hidden="true" />
        {message}
      </div>
    </div>
  )
}
